import React, { memo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from "react-i18next";

// styles
import './style.scss';

// antd component
import { Form, Input, Button } from 'antd';
const { TextArea } = Input;

// utils
import _local from "utils/localStorageUtils";

function RemarkForm({
  formData,
  isNew,
  isEdit,
  // actions
  nextStep,
  prevStep,
  goToStep,
  result,
  // default
  className,
}) {
  const childClassName = classNames('form-absence', className);
  const { t } = useTranslation();

  const localUser = _local.getLocalUser();

  const [isDisabled, setIsDisabled] = useState(false);

  const [AbsFormRemark] = Form.useForm();

  useEffect(() => {
    if (formData && formData?.remark) {
      AbsFormRemark.setFieldsValue(formData);
    }
  }, [formData]);

  const onFinish = values => {
    result(values);
    !!nextStep && nextStep();
    AbsFormRemark.resetFields();
  };

  const goPrevStep = () => {
    const absenceData = !!!isEdit?._id && formData || !!isEdit?._id && !formData?._id && isEdit || !!isEdit?._id && !!formData?._id && formData || formData;

    if (localUser?.role == "teacher") {
      !!prevStep && prevStep();
    } else {
      const hasMedia = !!!absenceData?.media || absenceData?.media.length > 0;
      const fomrMediaStep = !isNew && localUser?.role == "parent" ? 1 : 6;
      const previewMediaStep = !isNew && localUser?.role == "parent" ? 2 : 6;
      goToStep(hasMedia ? fomrMediaStep : previewMediaStep);
    }
  };

  return (
    <div className={childClassName}>
      <Form
        form={AbsFormRemark}
        className="form-absence__form"
        name="form_absence_undertake"
        initialValues={{
          remark: !!formData?.remark && formData?.remark || ""
        }}
        onFinish={onFinish}
        onValuesChange={() => setIsDisabled(false)}
      >
        <Form.Item
          name="remark"
          label={t("common.note")}
          className="remark-textarea"
          rules={[
            {
              required: false,
            },
          ]}
        >
          <TextArea disabled={false} row="10" placeholder={t("common.note")} />
        </Form.Item>

        <div className="absence-actions-wrapper">
          {!(isEdit?._id && localUser?.role == 'parent') && (
            <Button
              className="btn-previous"
              onClick={() => goPrevStep()}
              >
              {t("common.previous")}
            </Button>
          )}
          <Button
            className="next-btn"
            form="form_absence_undertake"
            htmlType="submit"
            disabled={isDisabled}
          >
            {t("common.next")}
          </Button>
        </div>
      </Form>
    </div>
  );
}

RemarkForm.defaultProps = {};
RemarkForm.propTypes = {
  result: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired,
  prevStep: PropTypes.func.isRequired,
  goToStep: PropTypes.func.isRequired,
};

export default memo(RemarkForm);
